import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Service } from "src/app/core/jsonapi/service";
import { Product } from "../_types/product";

@Injectable({
    providedIn: 'root',
})
export class ProductsService extends Service<Product> {
    public override type = 'products';
    public override url = 'invoicing/products';

    /**
     * Modulos distintos dados de alta en los precios, para alimentar el filtro de la lista.
     */
    public getModules(): Observable<string[]> {
        return this.http.get<string[]>(this.getAPIUrl() + '/modules');
    }
}
